import React, { Component } from 'react';
import {connect} from 'react-redux';
import { createDemoCategory, emptyDemographicsCategories} from '../../actions/demographics';
import AddDemoCategories from '../../components/demographics/addDemoCategory';

class AddDemographicsCategories extends Component {
  constructor(props){
    super(props)
    this.state={

    };
    this.categoryList = this.categoryList.bind(this);
    this.createDemoCategory = this.createDemoCategory.bind(this);
    this.emptyDemographicsCategories = this.emptyDemographicsCategories.bind(this);
  }


  categoryList(){
      this.props.history.push('/demographicsCategories');
  }

  createDemoCategory(data){
    this.props.dispatch(createDemoCategory(data));
  }

  emptyDemographicsCategories(){
    this.props.dispatch(emptyDemographicsCategories());
  }
  
  render(){
    let showAddDemographicsCategoriesView = <AddDemoCategories
            categoryList = {this.categoryList}
            createDemoCategory = {this.createDemoCategory}
            demoGraphicsCategoriesAddSuccess = {this.props.demoGraphicsCategoriesAddSuccess}
            demoGraphicsCategoriesResultData = {this.props.demoGraphicsCategoriesResultData}
            demoGraphicsCategoriesSuccessmessage = {this.props.demoGraphicsCategoriesSuccessmessage}
            demoGraphicsCategoriesFailmessage = {this.props.demoGraphicsCategoriesFailmessage}
            emptyDemographicsCategories = {this.emptyDemographicsCategories}
    />
      
    return (
        <div> 
             {showAddDemographicsCategoriesView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsCategoriesAddSuccess : state.demographics.demoGraphicsCategoriesAddSuccess,
    demoGraphicsCategoriesResultData : state.demographics.demoGraphicsCategoriesResultData,
    demoGraphicsCategoriesSuccessmessage : state.demographics.demoGraphicsCategoriesSuccessmessage,
    demoGraphicsCategoriesFailmessage : state.demographics.demoGraphicsCategoriesFailmessage,
  }
}

export default connect(mapStateToProps)(AddDemographicsCategories);



// WEBPACK FOOTER //
// ./src/pages/demographics/addDemoCategory.js